import { render, staticRenderFns } from "./set-price-limit.vue?vue&type=template&id=c405722c&scoped=true"
import script from "./set-price-limit.vue?vue&type=script&lang=js"
export * from "./set-price-limit.vue?vue&type=script&lang=js"
import style0 from "./set-price-limit.vue?vue&type=style&index=0&id=c405722c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c405722c",
  null
  
)

export default component.exports